import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import { FETCH_ERROR, REQUEST_LOADING } from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { ModulesService } from 'services/ModulesService';
import { formatDate } from 'utils';
import { ModulesForm } from './ModulesForm';
import { ModulesTable } from './ModulesTable';

function Modules() {
  useDocumentTitle('Модули');
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    state: { drawerVisible, activeRecord, formIsActive },
    openDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
    closeDrawer,
  } = useDrawers();
  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const { setCount } = useHeaderChanger('Модули');

  const recordFields = useMemo(() => {
    return [
      { label: 'Наименование', key: 'name' },
      { label: 'Slug', key: 'slug' },
      {
        label: 'Активный',
        key: 'active',
        computedValue: activeRecord?.active ? 'Да' : 'Нет',
      },
      {
        label: 'Дата создания',
        key: 'created',
        computedValue: formatDate(activeRecord?.created),
      },
    ];
  }, [activeRecord]);

  const fetchModules = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await ModulesService.getModules({
        page,
        perPage,
      });

      setModules(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => fetchModules(), [fetchModules]);

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await ModulesService.deleteModule(activeRecord?.id);

      if (isDeleted) {
        closeDrawer();
        fetchModules();
        message.success('Модуль успешно удален');
      }
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="modules" />

      <ModulesTable
        items={modules}
        loading={loading}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onRowClick={openDrawer}
        onChange={setPagination}
      />

      <ModulesForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchModules}
        onClose={closeForm}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        pageId="modules"
        recordFields={recordFields}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить этот модуль ?"
      />
    </>
  );
}

export { Modules };
